// material-ui
import { Box, useMediaQuery } from '@mui/material';

// project-imports
import Profile from './Profile';
import Notification from './Notification';
import MobileSection from './MobileSection';

import Breadcrumbs from 'components/@extended/Breadcrumbs';
import navigation from 'menu-items';
import { useHeaderAction } from 'contexts/HeaderActionContext';
import useConfig from 'hooks/useConfig';
import DrawerHeader from 'layout/MainLayout/Drawer/DrawerHeader';
import { MenuOrientation } from 'config';

// ==============================|| HEADER - CONTENT ||============================== //

const HeaderContent = () => {
  const { menuOrientation } = useConfig();
  const { action } = useHeaderAction();

  const downLG = useMediaQuery((theme) => theme.breakpoints.down('lg'));

  return (
    <>
      {menuOrientation === MenuOrientation.HORIZONTAL && !downLG && (
        <DrawerHeader open={true} />
      )}

      {/* page breadcrumb trail — lives in the app bar to free up content space */}
      <Breadcrumbs
        navigation={navigation}
        compact
        sx={{ display: { xs: 'none', md: 'flex' }, mr: 1 }}
      />

      {/* push the actions to the right */}
      <Box sx={{ flexGrow: 1 }} />

      {action && (
        <Box sx={{ display: 'flex', alignItems: 'center', mr: 1 }}>
          {action}
        </Box>
      )}
      <Notification />
      {!downLG && <Profile />}
      {downLG && <MobileSection />}
    </>
  );
};

export default HeaderContent;
